module.exports = __webpack_public_path__ + "assets/img/aboutUS-module1-6.15ced66d.jpg";